import React, { Component } from "react";
import { graphql } from "react-apollo";
import styled from "styled-components";
import { Scrollbars } from "react-custom-scrollbars";
import Row from './Row'

export default class List extends Component {

    render() {
        const { members } = this.props

        const renderLists = members.map((row, index) => (
            <Row
                key={"list" + row.id}
                id={row.id}
                index={index + 1}
                firstName={row.fields.firstName}
                lastName={row.fields.lastName}
                email={row.emailAddress}
            />
        ));

        const content = <Content>
            <ListWrapper>
                <ListTitle>
                    <Index>No.</Index>
                    <Name>First Name</Name>
                    <Name>Last Name</Name>
                    <Contact>Email</Contact>
                    <Label>Tags</Label>
                    <Index></Index>
                </ListTitle>
                {renderLists}
            </ListWrapper>
        </Content>

        return <Wrapper>
            <Scrollbars
                ref={ref => (this.scroller = ref)}
                onScrollFrame={this.onScrollFrame}
            >
                {content}
            </Scrollbars>
        </Wrapper>
    }

}

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  /* overflow: scroll; */
`;

const Header = styled.div`
  display: flex;
  flex: none;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  border-bottom: 1px solid #d2d3d5;
`;

const Title = styled.div`
  font-size: 1.1rem;
  font-weight: 500;
  color: #087cbc;
`;

const Back = styled.span`
  cursor: pointer;
`;

const Content = styled.div`
  padding: 10px 20px;
`;

const FilterWrapper = styled.div`
  width: 400px;
`;

const ListWrapper = styled.div`
  margin-top: 10px;
`;

const ListTitle = styled.div`
  background: #20445a;
  color: #fff;
  font-weight: 600;
  font-size: 0.95rem;
  display: flex;
  flex-direction: row;
  padding: 5px 10px;
`;

const Index = styled.div`
  margin-left: 10px;
  flex: 1;
`;

const Name = styled.div`
  flex: 4;
  text-align: left;
`;

const Contact = styled.div`
  flex: 3;
  text-align: left;
`;

const SocialMedia = styled.div`
  flex: 2;
  text-align: center;
`;

const Label = styled.div`
  flex: 4;
  margin-right: 10px;
`;



// WEBPACK FOOTER //
// ./src/module-email-campaign/audience/member/List.js